import React  from "react";


const Modal = ({onClose, navOpen, isModalOpen}) => {
    return(
        <div>
            <div className="md:block hidden">
                <div
                    className="
                    fixed inset-0
                    bg-black/50
                    z-30 
                    flex
                    "
                    onClick={onClose} 
                >
                    <div
                    className={`
                        relative 
                        flex
                        flex-row
                        items-center
                        
                        h-[186px]
                        w-[517px]     /* ширина окна */
                        bg-white 
                        border border-gray-300 
                        rounded-[20px]
                        shadow-lg
                        m-4          /* отступ от краёв экрана */
                        ${navOpen ? `lg:ml-[325px]` : 'lg:ml-[130px]'}
                        ml-[100px]
                        mt-auto
                        ${navOpen ? `mb-[14%]` : 'mb-[150px]'}
                        transition-all duration-300
                        ${isModalOpen ? `opacity-100` : 'opacity-0'}
                        leading-tight
                        py-5
                        px-6
                    `}
                    onClick={(e) => e.stopPropagation()}
                    style={{ overflow: "hidden" }}
                    >
                        <div className="w-1/2 h-full flex flex-col justify-start pr-4 gap-2">
                            <h2 className="text-[24px] font-semibold mb-1">
                                У вас пока нет активных заявок
                            </h2>
                            <p className="text-[16px]">
                                Воспользуйтесь нашим подробным калькулятором, <br />
                                для просчёта вашего груза
                            </p>
                        </div>

                        <div
                            className="relative w-1/2 h-full"
                        >
                            
                            <div
                                className="
                                absolute
                                top-1/2
                                -translate-y-1/2
                                right-[-120px]  /* Сдвигаем за пределы, чтобы часть вышла наружу */
                                h-[250px]
                                w-[350px]
                                bg-no-repeat
                                bg-contain
                                "
                                style={{
                                backgroundImage: "url(/img/lk/Modal/car.png)",
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="md:hidden block">
                <div
                    className="
                    fixed inset-0
                    bg-black/50
                    z-50 
                    flex
                    items-center
                    justify-center
                    "
                    onClick={onClose} 
                >
                    <div
                    className={`
                        relative 
                        flex
                        flex-col-reverse
                        justify-between
                        items-center
                        
                        h-[368px]
                        w-[343px]     /* ширина окна */
                        bg-white 
                        border border-gray-300 
                        rounded-[20px]
                        shadow-lg
                        m-4          /* отступ от краёв экрана */
                        
                        transition-all duration-300
                        ${isModalOpen ? `opacity-100` : 'opacity-0'}
                        
                        py-5
                        px-7
                    `}
                    onClick={(e) => e.stopPropagation()}
                    style={{ overflow: "hidden" }}
                    >
                        {/* СОЗДАТЬ НОВУЮ ЗАЯВКУ */}
                        <div className="cursor-pointer w-[110%] py-[10px] mt-2 px-[30px] flex flex-row items-center justify-center gap-[10px] bg-[#fff] rounded-[12px] border-dashed border-[1px]"
                            style={{ borderColor: `#C3372E` }}>
                            <a href="/calculator" className="flex flex-row items-center justify-center gap-[10px]">
                                <div>
                                    <img src="/img/lk/Modal/zayavka_modal.svg" alt="New Application" />
                                </div>
                                <div>
                                    Создать новую заявку
                                </div>
                            </a>
                            
                        </div>
                        <div className="w-full h-full flex flex-col justify-start items-center text-center px-5 gap-1 mt-5">
                            
                            <h2 className="text-[22px] font-semibold">
                                У вас пока нет активных заявок
                            </h2>
                            <p className="text-[14px] font-medium">
                                Воспользуйтесь нашим подробным калькулятором, <br />
                                для просчёта вашего груза
                            </p>
                        </div>

                        <div className="w-full h-[105px] flex items-center justify-center">
                            <img
                                src="/img/lk/Modal/car.png"
                                alt="Грузовик"
                                className="object-contain"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        
    )
}

export default Modal;
